module.exports = __webpack_public_path__ + "assets/6ed98e44d97022ec6fe5f8958954c56a.mp3";